import { render, staticRenderFns } from "./DActiveStatusIcon.vue?vue&type=template&id=13909a7e"
import script from "./DActiveStatusIcon.vue?vue&type=script&lang=js"
export * from "./DActiveStatusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports